export function numberToCurrency(value: number | string): string {
  const convertedValue = Number(value);

  if (!convertedValue?.toString() || Number.isNaN(value)) {
    return "--";
  }

  return convertedValue.toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });
}

const brlFormatter = new Intl.NumberFormat("pt-BR", {
  style: "currency",
  currency: "BRL",
});

export function formatBRL(value: string | number): string {
  const parsedValue =
    typeof value === "string" ? Number(value.replace(",", ".")) : value;

  if (Number.isNaN(parsedValue)) {
    return "R$ 0,00";
  }

  return brlFormatter.format(parsedValue);
}
